export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6569.05a38352.jpg";